import { useLocalStorage } from "usehooks-ts";

interface TableColumn {
  id: string;
  title: string;
}

export function useVisibleColumns<Column extends TableColumn>(
  tableName: string,
  columns: readonly Column[],
): {
  visibleColumns: Column[];
  selectedColumns: string[];
  setSelectedColumns: (selectedColumns: string[]) => void;
} {
  const [selectedColumns, setSelectedColumns] = useLocalStorage<string[]>(`table-columns:${tableName}`, []);

  return {
    visibleColumns: columns.filter((column) => selectedColumns.includes(column.id)),
    selectedColumns,
    setSelectedColumns,
  };
}
